import { css } from '@emotion/react';

import { Theme } from './theme/type';
import { coBrandSpringBottomSheet } from './theme/custom-components';

const Style = (props: Theme) => {
  const {
    typography,
    palette,
    customComponents: { modal },
    breakpoints,
  } = props;
  return css`
    /* @font-face {
      font-family: 'Avenir';
      font-style: normal;
      font-weight: 200;
      src: local('Avenir Book'), local('Avenir-Book'),
        url('../fonts/avenir/Avenir-Book.woff2') format('woff2');
    }
    @font-face {
      font-family: 'Avenir';
      font-style: normal;
      font-weight: 400;
      src: local('Avenir Medium'), local('Avenir-Medium'),
        url('../fonts/avenir/Avenir-Medium.woff2') format('woff2');
    }
    @font-face {
      font-family: 'Avenir';
      font-style: normal;
      font-weight: 700;
      src: local('Avenir Black'), local('Avenir-Black'),
        url('../fonts/avenir/Avenir-Black.woff2') format('woff2');
    } */

    html {
      font-family: 'Avenir LT Pro';
      font-size: ${typography.htmlFontSize}px;
      color: ${palette.common.black};
    }

    body {
      touch-action: pan-x pan-y;
    }

    [data-rsbs-overlay] {
      z-index: ${modal.contentZIndex} !important;
    }

    .react-spring-bottom-sheet {
      position: fixed;
      left: 0;
      bottom: 0;
      right: 0;
      top: 0;
      display: flex;
      justify-content: center;
      z-index: ${coBrandSpringBottomSheet.backdrop.zIndex};
      div[data-rsbs-backdrop] {
        z-index: ${coBrandSpringBottomSheet.backdrop.zIndex};
      }
      div[role='dialog'] {
        max-width: ${breakpoints.values.sm}px;
        box-sizing: border-box;
        margin: 0 auto;
      }
    }
  `;
};

export default Style;
